'use strict';

class CheckIMEI {
	constructor(props) {
		this.recaptcha = null;
		this.recaptcha_site_key = null;
		this.auto_check_imei = false;
		this.form_id = 'form_check_imei';

		let _that = this;
		_that = Object.assign(this, props);
		console.log('CheckIMEI::constructor(%o)', props);

		_that.form = document.querySelector(`#${_that.form_id}`);
		_that.imei_field = _that.form.querySelector('[name=imei]');

		_that.input_type_toggle = _that.form.querySelector('.input_type_toggle');
		_that.check_imei_button = _that.form.querySelector('#check_imei_button');
		_that.check_imei_response = document.querySelector('#form_check_imei_response');

		if (_that.recaptcha) {
			_that.recaptcha.ready(() => {
				_that.recaptcha.render('recaptcha', {
					'sitekey': _that.recaptcha_site_key,
					'size': 'invisible',
					'callback': (token) => {
						_that.doAjax(token)
							.then(response => {
								_that.validateImeiCodeSuccess(response);
							})
							.catch(reason => {
								_that.validateImeiReset();
							});
					},
					'expired-callback': (a, b, c) => {
						console.log('expired-callback()');
						_that.recaptcha.reset();
					},
					'error-callback': (a, b, c) => {
						console.log('error-callback(%o, %o, %o)', a, b, c);
					},
				});

				_that.doInit();
			});
		} else {
			_that.doInit();
		}

		if (typeof _that.tooltip_image_url !== 'undefined') {
			const img = document.createElement('img');
			img.src = _that.tooltip_image_url;
			img.addEventListener('load', () => {
				img.remove();
			}, false);
		}

		$('[data-toggle="popover-image"]').popover({html: true});

		_that.imei_field.addEventListener('input', e => {
			_that.check_imei_button.disabled = e.target.value === '';
			_that.check_imei_response.innerHTML = '';
		}, false);

		_that.check_imei_button.addEventListener('click', e => {
			_that.formSubmit(e);
		}, false);

		_that.form.addEventListener('submit', e => {
			_that.formSubmit(e);
		}, false);

		'click touch'.split(' ').forEach(e => {
			_that.input_type_toggle.addEventListener(e, () => {
				_that.toggleInputType(_that.imei_field);
			}, false);
		});
	}

	doInit() {
		const _that = this;

		_that.imei_field.readOnly = false;
		if (_that.imei_field.value !== '') {
			_that.check_imei_button.disabled = false;
		}
		if (_that.auto_check_imei && _that.imei_field.value !== '') {
			_that.check_imei_button.dispatchEvent(new Event('click'));
		}
	}

	formSubmit(e) {
		e.preventDefault();

		let _that = this;
		_that.check_imei_button.disabled = true;
		_that.imei_field.readOnly = true;
		_that.check_imei_response.innerHTML = '<svg class=\'spinner\' viewBox=\'0 0 50 50\'><circle class=\'path\' cx=\'25\' cy=\'25\' r=\'20\' fill=\'none\' stroke-width=\'5\'></circle></svg>';

		if (_that.recaptcha !== null) {
			_that.recaptcha.execute();
		} else {
			_that.doAjax()
				.then(response => {
					_that.validateImeiCodeSuccess(response);
				})
				.catch(reason => {
					_that.validateImeiReset(true);
				})
			;
		}

		return false;
	}

	toggleInputType(input, new_type = 'text') {
		let old_type = input.dataset.old_type;
		if (typeof old_type === 'undefined') {
			old_type = new_type;
		}

		const type = input.getAttribute('type');
		input.dispatchEvent(new Event('blur'));

		input.setAttribute('type', old_type);
		input.dataset.old_type = type;
		input.focus();

		setTimeout(() => {
			input.selectionStart = input.selectionEnd = input.value.length;
		}, 0);
	}

	validateImeiCodeSuccess(response) {
		console.log('CheckIMEI::validateImeiCodeSuccess(%o)', response);
		let _that = this;
		_that.form.dispatchEvent(new CustomEvent('imei_checked', {detail: response}));

		let _gtm_message = '';
		if (response.result) {
			_gtm_message = 'ESN OK - Join';
		} else {
			// TODO check if we still actually need all of these
			switch (response.status) {
				case 'incompatible_device':
					_gtm_message = 'ESN Not OK - Incompatible device';
					break;

				case 'downtime_active':
					_gtm_message = 'supplier downtime';
					break;

				case 'active_device':
					_gtm_message = 'ESN OK - Already with Tello';
					break;

				case 'fed_not_met':
					_gtm_message = 'ESN OK - Fed not Met';
					break;

				case 'port_in_required':
					_gtm_message = 'ESN OK - Port In required';
					break;

				case 'active_sim':
				case 'invalid_iccid':
				default:
					_gtm_message = 'ESN Not OK - Incorrect';
			}
		}
		dataLayerPush({
			'event': 'gtm_check_esn',
			'result': _gtm_message
		});

		_that.check_imei_response.innerHTML = response.html;
		_that.validateImeiReset();
	}

	validateImeiReset() {
		console.log('CheckIMEI::validateImeiReset()');
		let _that = this;
		_that.form.dispatchEvent(new CustomEvent('imei_checked', {detail: false}));

		if (_that.recaptcha !== null) {
			_that.recaptcha.reset();
		}
		_that.check_imei_button.disabled = false;
		_that.imei_field.readOnly = false;
	}

	doAjax(token = '') {
		console.log('CheckIMEI::doAjax()');
		let _that = this;

		return new Promise((resolve, reject) => {
			const data = {
				action: 'check_gsm_imei',
				imei: _that.imei_field.value,
				page_name: _page_name,
			};
			if (token) {
				data['g-recaptcha-response'] = token;
			}
			$.ajax({
				type: 'post',
				url: url('/process_byod'),
				data: data,
				success: (response) => {
					resolve(response);
				},
				error: (err) => {
					reject(err);
				}
			});
		});
	}
}

if (!check_imei_options.recaptcha_site_key) {
	document.addEventListener('DOMContentLoaded', () => {
		try {
			check_imei_options.recaptcha = null;
			new CheckIMEI(check_imei_options);
		} catch (e) {
			console.error(e);
		}
	});
}

function initRecaptcha(onload = false) {
	try {
		check_imei_options.recaptcha = typeof grecaptcha !== 'undefined' ? grecaptcha : null;
		if (!check_imei_options.recaptcha) {
			check_imei_options.recaptcha_site_key = null;
		}

		if (onload) {
			document.addEventListener('DOMContentLoaded', () => {
				new CheckIMEI(check_imei_options);
			});
		} else {
			new CheckIMEI(check_imei_options);
		}
	} catch (e) {
		console.error(e);
	}
}
